// ── IMAGE GALLERY ──
var currentImg = 0;

function switchImg(idx, el) {
  if (typeof productImages === 'undefined') return;
  currentImg = idx;
  var mainImg = document.getElementById('mainImg');
  if (!mainImg) return;
  mainImg.style.opacity = '0';
  setTimeout(function() {
    mainImg.src = productImages[idx];
    mainImg.style.opacity = '1';
    var zoomImg = document.getElementById('zoomImg');
    if (zoomImg) zoomImg.src = productImages[idx];
  }, 200);
  document.querySelectorAll('.thumb').forEach(function(t) { t.classList.remove('active'); });
  if (el) el.classList.add('active');
}

function prevImg() {
  if (typeof productImages === 'undefined') return;
  currentImg = (currentImg - 1 + productImages.length) % productImages.length;
  switchImg(currentImg, document.querySelectorAll('.thumb')[currentImg]);
}

function nextImg() {
  if (typeof productImages === 'undefined') return;
  currentImg = (currentImg + 1) % productImages.length;
  switchImg(currentImg, document.querySelectorAll('.thumb')[currentImg]);
}

// ── ZOOM MODAL ──
function openZoom() {
  if (typeof productImages !== 'undefined') {
    var z = document.getElementById('zoomImg');
    if (z) z.src = productImages[currentImg];
  }
  var modal = document.getElementById('zoomModal');
  if (modal) { modal.classList.add('open'); document.body.style.overflow = 'hidden'; }
}
function closeZoom() {
  var modal = document.getElementById('zoomModal');
  if (modal) { modal.classList.remove('open'); document.body.style.overflow = ''; }
}

// ── QUANTITY ──
function changeQty(d) {
  var inp = document.getElementById('qtyInput');
  var sInp = document.getElementById('stickyQty');
  if (!inp) return;
  var v = Math.min(Math.max(parseInt(inp.value) + d, 1), 20);
  inp.value = v;
  if (sInp) sInp.value = v;
}

// ── CART DRAWER ──
function openCart() {
  var cart = document.getElementById('miniCart');
  var overlay = document.getElementById('cartOverlay');
  if (cart) cart.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  var cart = document.getElementById('miniCart');
  var overlay = document.getElementById('cartOverlay');
  if (cart) cart.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

// ── MOBILE NAV DRAWER ──
function openDrawer() {
  var d = document.getElementById('drawer');
  var o = document.getElementById('drawerOverlay');
  if (d) d.classList.add('open');
  if (o) o.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeDrawer() {
  var d = document.getElementById('drawer');
  var o = document.getElementById('drawerOverlay');
  if (d) d.classList.remove('open');
  if (o) o.classList.remove('open');
  document.body.style.overflow = '';
}

// ── ACCORDION / FAQ ──
function toggleAcc(header) {
  var item = header.parentElement;
  var wasOpen = item.classList.contains('open');
  document.querySelectorAll('.acc-item').forEach(function(i) { i.classList.remove('open'); });
  if (!wasOpen) item.classList.add('open');
}
function toggleFaq(question) {
  var item = question.parentElement;
  var wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
  if (!wasOpen) item.classList.add('open');
}

// ── STICKY ATC ──
(function() {
  var buyBox = document.getElementById('buyBox');
  var stickyAtc = document.getElementById('stickyAtc');
  if (buyBox && stickyAtc) {
    new IntersectionObserver(function(entries) {
      stickyAtc.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(buyBox);
  }
})();

// ── SHARE ──
function shareProduct(platform) {
  var url = encodeURIComponent(window.location.href);
  var text = encodeURIComponent(document.title);
  var links = {
    whatsapp: 'https://wa.me/?text=' + text + '%20' + url,
    facebook: 'https://facebook.com/sharer/sharer.php?u=' + url,
    twitter: 'https://twitter.com/intent/tweet?text=' + text + '&url=' + url
  };
  if (links[platform]) window.open(links[platform], '_blank');
}
function copyLink() {
  if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).then(function() { showToast('Link copied!'); });
}

// ── TOAST ──
var toastTimer;
function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function() { t.classList.remove('show'); }, 2800);
}

// ── BUY NOW ──
function buyNow() {
  var variantId = document.getElementById('variantId');
  var qtyInput = document.getElementById('qtyInput');
  if (!variantId) return;
  var id = parseInt(variantId.value);
  var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
  if (!id) return;
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: qty }) })
    .then(function(res) { if (!res.ok) throw new Error(); return res.json(); })
    .then(function() { window.location.href = '/checkout'; })
    .catch(function() { showToast('Could not proceed to checkout. Please try again.'); });
}

// ── VARIANT SELECTOR ──
function selectVariantOption(btn, optionName, value) {
  btn.parentElement.querySelectorAll('button').forEach(function(b) { b.style.borderColor = 'var(--smoke)'; b.classList.remove('selected'); });
  btn.style.borderColor = 'var(--warm-white)';
  btn.classList.add('selected');
  if (typeof productVariants !== 'undefined') {
    var sel = [];
    document.querySelectorAll('.variant-option.selected').forEach(function(el) { sel.push(el.textContent.trim()); });
    for (var i = 0; i < productVariants.length; i++) {
      var v = productVariants[i], match = true;
      for (var j = 0; j < sel.length; j++) { if (v['option'+(j+1)] !== sel[j]) { match = false; break; } }
      if (match) {
        document.getElementById('variantId').value = v.id;
        var priceEl = document.getElementById('displayPrice');
        if (priceEl) priceEl.textContent = (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? Shopify.formatMoney(v.price) : 'Rs. '+(v.price/100).toLocaleString();
        if (v.featured_image && v.featured_image.src) {
          var base = v.featured_image.src.split('?')[0], idx = 0;
          for (var k = 0; k < productImages.length; k++) { if (productImages[k].split('?')[0] === base) { idx = k; break; } }
          switchImg(idx, document.querySelectorAll('.thumb')[idx] || null);
        }
        break;
      }
    }
  }
}

// ── AJAX ADD TO CART ──
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-quick-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function(r) { return r.json(); })
        .then(function(d) { showToast('Added to cart: '+d.title); updateCartCount(); openCart(); refreshCartDrawer(); })
        .catch(function() { showToast('Could not add to cart'); });
    });
  });
  var pf = document.getElementById('productForm');
  if (pf) {
    pf.addEventListener('submit', function(e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pf) })
        .then(function(r) { return r.json(); })
        .then(function(d) { showToast('Added to cart: '+d.title); updateCartCount(); openCart(); refreshCartDrawer(); })
        .catch(function() { showToast('Could not add to cart'); });
    });
  }
});

// ── BUNDLE DISCOUNT CODES ──
var CART_BUNDLE_CODES = { 10:'BB-X7K2-SAVE10-QP91', 18:'BB-M4N8-SAVE18-WZ63', 22:'BB-R9T5-SAVE22-JH47', 28:'BB-V3L6-SAVE28-YC82' };
var CART_BUNDLE_TIERS = [[5,28],[4,22],[3,18],[2,10],[0,0]];

function cartGetDiscountPct(itemCount) {
  for (var i = 0; i < CART_BUNDLE_TIERS.length; i++) { if (itemCount >= CART_BUNDLE_TIERS[i][0]) return CART_BUNDLE_TIERS[i][1]; }
  return 0;
}
function cartSyncDiscount(itemCount) {
  var pct = cartGetDiscountPct(itemCount);
  var code = pct > 0 ? CART_BUNDLE_CODES[pct] : 'REMOVE';
  fetch('/discount/'+encodeURIComponent(code), { method:'GET', credentials:'same-origin' }).catch(function(){});
}

// ── REMOVE SINGLE ITEM (non-bundle) — optimistic ──
function cartRemoveItem(itemKey) {
  // Optimistically remove row
  var rows = document.querySelectorAll('#cartItems .ci');
  var targetRow = null;
  rows.forEach(function(row) {
    var btn = row.querySelector('.ci-remove');
    if (btn && btn.getAttribute('onclick') && btn.getAttribute('onclick').indexOf(itemKey) !== -1) targetRow = row;
  });
  if (targetRow) {
    targetRow.style.transition = 'opacity .15s, transform .15s';
    targetRow.style.opacity = '0';
    targetRow.style.transform = 'translateX(12px)';
    setTimeout(function() {
      if (targetRow.parentNode) targetRow.parentNode.removeChild(targetRow);
      if (!document.querySelectorAll('#cartItems .ci, #cartItems .ci-bundle').length) {
        var el = document.getElementById('cartItems');
        if (el) el.innerHTML = '<p style="text-align:center;color:var(--ash);font-size:14px;margin-top:48px;font-family:var(--font-serif);font-style:italic">Your cart is empty.<br>Start with a candle.</p>';
      }
    }, 150);
  }
  fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:itemKey,quantity:0}) })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.cart-count,#headerCartCount,#cartCount').forEach(function(el){el.textContent=cart.item_count;});
      var t = document.getElementById('cartTotal'); if (t) t.textContent = formatMoney(cart.total_price);
      cartSyncDiscount(cart.item_count);
      refreshCartDrawer();
    })
    .catch(function() { refreshCartDrawer(); showToast('Could not remove item.'); });
}

// ── REMOVE ENTIRE BUNDLE — all items sharing the same bundle_id ──
function cartRemoveBundle(keysStr) {
  // keysStr is comma-separated item keys e.g. "abc123:1,def456:1,"
  var keys = keysStr.split(',').filter(function(k) { return k.trim() !== ''; });
  if (!keys.length) return;

  // Optimistically hide the bundle block immediately
  var bundleBlocks = document.querySelectorAll('#cartItems .ci-bundle');
  bundleBlocks.forEach(function(block) {
    var removeBtn = block.querySelector('.ci-bundle-remove');
    if (removeBtn && removeBtn.getAttribute('onclick') && removeBtn.getAttribute('onclick').indexOf(keys[0]) !== -1) {
      block.style.transition = 'opacity .15s, transform .15s';
      block.style.opacity = '0';
      block.style.transform = 'translateX(12px)';
      setTimeout(function() { if (block.parentNode) block.parentNode.removeChild(block); }, 150);
    }
  });

  // Remove all bundle items sequentially via cart/change.js
  var chain = Promise.resolve();
  keys.forEach(function(key) {
    chain = chain.then(function() {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key.trim(), quantity: 0 })
      }).then(function(r) { return r.json(); });
    });
  });

  chain.then(function(cart) {
    // Clear discount since bundle is gone
    fetch('/discount/REMOVE', { method:'GET', credentials:'same-origin' }).catch(function(){});
    document.querySelectorAll('.cart-count,#headerCartCount,#cartCount').forEach(function(el){el.textContent=cart.item_count;});
    var t = document.getElementById('cartTotal'); if (t) t.textContent = formatMoney(cart.total_price);
    showToast('Bundle removed.');
    refreshCartDrawer();
  }).catch(function() {
    refreshCartDrawer();
    showToast('Could not remove bundle.');
  });
}

// ── RENDER CART ITEMS (for AJAX refresh) ──
function renderCartItems(cart) {
  var itemsEl = document.getElementById('cartItems');
  var totalEl = document.getElementById('cartTotal');
  var countEl = document.getElementById('cartCount');
  if (countEl) countEl.textContent = cart.item_count;
  if (!itemsEl) return;
  if (!cart.items || !cart.items.length) {
    itemsEl.innerHTML = '<p style="text-align:center;color:var(--ash);font-size:14px;margin-top:48px;font-family:var(--font-serif);font-style:italic">Your cart is empty.<br>Start with a candle.</p>';
    if (totalEl) totalEl.textContent = formatMoney(0);
    return;
  }

  var html = '';
  var renderedBundles = {};
  var totalDiscount = 0;

  cart.items.forEach(function(item) {
    var bundleId = item.properties && item.properties['_bundle_id'];
    var discountPct = item.properties && item.properties['_bundle_discount'];
    var hasDiscount = item.original_line_price !== item.final_line_price;
    if (hasDiscount) totalDiscount += (item.original_line_price - item.final_line_price);

    if (!bundleId) {
      // Regular item
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title+'<br>' : '';
      var priceHtml = '<div class="ci-price-wrap">'+(hasDiscount?'<span class="ci-price-orig">'+formatMoney(item.original_line_price)+'</span>':'')+'<span class="ci-price">'+formatMoney(item.final_line_price)+'</span></div>';
      html += '<div class="ci"><div class="ci-img"><img src="'+(item.image||'')+'"></div><div style="flex:1;min-width:0"><div class="ci-name">'+item.product_title+'</div><div class="ci-meta">'+variantLabel+'Qty: '+item.quantity+'</div><button class="ci-remove" onclick="cartRemoveItem(\''+item.key+'\')" type="button">Remove</button></div>'+priceHtml+'</div>';
    } else if (!renderedBundles[bundleId]) {
      // First item of this bundle — render entire bundle block
      renderedBundles[bundleId] = true;
      var bundleItems = cart.items.filter(function(bi) { return bi.properties && bi.properties['_bundle_id'] === bundleId; });
      var bundleKeys = bundleItems.map(function(bi) { return bi.key; }).join(',');
      var bundleOrig = bundleItems.reduce(function(s,bi){return s+bi.original_line_price;},0);
      var bundleFinal = bundleItems.reduce(function(s,bi){return s+bi.final_line_price;},0);
      var bundleHasDiscount = bundleOrig !== bundleFinal;

      var rowsHtml = bundleItems.map(function(bi) {
        var vl = (bi.variant_title && bi.variant_title !== 'Default Title') ? ' · '+bi.variant_title : '';
        var ph = '<div class="ci-price-wrap">'+(bi.original_line_price!==bi.final_line_price?'<span class="ci-price-orig">'+formatMoney(bi.original_line_price)+'</span>':'')+'<span class="ci-price">'+formatMoney(bi.final_line_price)+'</span></div>';
        return '<div class="ci-bundle-row"><div class="ci-bundle-img"><img src="'+(bi.image||'')+'"></div><div class="ci-bundle-name">'+bi.product_title+vl+'</div>'+ph+'</div>';
      }).join('');

      html += '<div class="ci-bundle">'+
        '<div class="ci-bundle-header">'+
          '<div class="ci-bundle-label"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>Your Bundle'+(discountPct?'<span class="ci-bundle-badge">'+discountPct+' off</span>':'')+'</div>'+
          '<button class="ci-bundle-remove" onclick="cartRemoveBundle(\''+bundleKeys+'\')" type="button">Remove Bundle</button>'+
        '</div>'+
        '<div class="ci-bundle-items">'+rowsHtml+'</div>'+
        '<div class="ci-bundle-total"><span>Bundle total</span><div class="ci-price-wrap">'+(bundleHasDiscount?'<span class="ci-price-orig">'+formatMoney(bundleOrig)+'</span>':'')+'<span class="ci-price">'+formatMoney(bundleFinal)+'</span></div></div>'+
      '</div>';
    }
  });

  itemsEl.innerHTML = html;
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
}

function updateCartCount() {
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    document.querySelectorAll('.cart-count,#headerCartCount,#cartCount').forEach(function(el){el.textContent=cart.item_count;});
  });
}
function refreshCartDrawer() {
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){renderCartItems(cart);}).catch(function(){});
}
function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents);
  return 'Rs. '+(cents/100).toLocaleString();
}
